<script setup>
import {defineEmits, defineProps, defineExpose, ref} from 'vue';

const filter = ref({});

const emits = defineEmits(['filter']);

const props = defineProps({
  branches: {
    type: Array,
    required: true
  },
  profiles: {
    type: Array,
    required: true
  },
  hideProfile: {
    type: Boolean,
    required: false,
    default: false
  },
  disableFilter: {
    type: Boolean,
    required: false,
    default: false
  }
});

const submit = () => {
  emits('filter', filter.value);
}

defineExpose({
  filter,
  submit
});
</script>

<template>
  <Fieldset legend="Filtros">
    <form @submit.prevent="submit">
      <div class="flex">
        <div class="w-3 p-2">
          <label for="filterBranches" class="block">Unidades</label>
          <MultiSelect id="filterBranches"
                       v-model="filter.branches"
                       :options="props.branches"
                       optionLabel="name"
                       optionValue="id"
                       placeholder="Selecione as unidades"
                       empty-message="Nenhum registro encontrado"
                       emptyFilterMessage="Nenhum registro encontrado"
                       :maxSelectedLabels="3"
                       :virtualScrollerOptions="{ itemSize: 44 }"
                       :selectedItemsLabel="filter.branches?.length + ' unidades selecionadas'"
                       filter
                       class="w-12"
                       showClear/>
        </div>

        <div class="w-3 p-2" v-if="!hideProfile">
          <label for="filterProfile" class="block">Perfil</label>
          <Select id="filterProfile"
                  v-model="filter.profile"
                  :options="props.profiles"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Selecione um perfil"
                  empty-message="Nenhum registro encontrado"
                  class="w-12"
                  showClear/>
        </div>

        <div class="w-3 p-2">
          <label for="filterName" class="block">Nome</label>
          <InputText id="filterName"
                     v-model="filter.name"
                     class="w-12"/>
        </div>

        <div class="w-3 p-2">
          <label for="filterEmail" class="block">E-mail</label>
          <InputText id="filterEmail"
                     v-model="filter.email"
                     class="w-12"/>
        </div>
      </div>

      <div class="w-12 flex justify-content-start mt-3">
        <Button label="Filtrar"
                type="submit"
                :disabled="props.disableFilter"
                icon="pi pi-filter"/>
      </div>
    </form>
  </Fieldset>
</template>